import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import {
  getDefaultAdminTarget,
  getLegacyAdminTarget,
  mergeAdminTarget,
} from './adminNavConfig';

const MapDialogPreview = React.lazy(() => import('../MapDialog/MapDialogPreview'));

function AdminLegacyRedirect() {
  const { pathname, search, hash } = useLocation();
  const normalizedPathname = pathname.endsWith('/') && pathname !== '/'
    ? pathname.slice(0, -1)
    : pathname;

  if (normalizedPathname === '/admin/mapdialog-preview') {
    return (
      <React.Suspense fallback={<div className="suspense-spinner" />}>
        <MapDialogPreview />
      </React.Suspense>
    );
  }

  const target = getLegacyAdminTarget(pathname) || getDefaultAdminTarget('review');
  const redirectTarget = mergeAdminTarget(target, search, hash);

  return <Navigate to={redirectTarget} replace />;
}

export default AdminLegacyRedirect;
